import type {
  RosterChoiceResponse,
  RosterSyncResponse,
  UserClassroomsFilters,
  UserClassroomsResponse,
} from "./queries.types";

export const userClassroomsMock: UserClassroomsResponse = {
  count: 2,
  results: [
    {
      id: 2,
      pk: 2,
      unique_id: "250eb77b3c9f4b439b82b861f4331a90",
      name: "Active Classroom 201",
      class_code: "PRGMXU",
      grade: 9,
      is_elementary: false,
      date_created: "2024-05-07T18:11:03Z",
      date_modified: "2024-05-07T18:11:03Z",
      date_archived: null,
      archived_by: "",
      provider: {
        name: "Newsela",
        internal_name: "native",
        unique_id: null,
        is_bulk: false,
      },
      school: {
        id: 2000287682,
        pk: 2000287682,
        unique_id: "80e2fd9ef73f4c4e89927dc6891b1d11",
        name: "Lite District High School",
      },
      most_recent_sync_start_date: null,
      most_recent_sync_end_date: null,
      subjects: [
        {
          title: "Social Studies/Social Science",
          slug: "social-studies",
          date_created: "2019-07-19T22:24:39Z",
          date_modified: "2019-07-19T22:24:39Z",
        },
      ],
      teachers: [
        {
          id: 8,
          pk: 8,
          unique_id: "2934df5d36514e6a8163348bfa6347b9",
          user: {
            id: 20,
            pk: 20,
            unique_id: "2934df5d36514e6a8163348bfa6347b9",
            first_name: "lite",
            last_name: "Teacher",
            last_login: "2024-10-15T16:19:09Z",
            social_auths: [],
          },
        },
      ],
      students: [
        {
          id: 11,
          pk: 11,
          unique_id: "53ae0743e208498293c88d3efb28bc46",
          user: {
            id: 21,
            pk: 21,
            unique_id: "53ae0743e208498293c88d3efb28bc46",
            first_name: "Dana Bradley",
            last_name: "Juan Walker",
            last_login: null,
            social_auths: [],
          },
        },
      ],
    },
    {
      id: 3,
      pk: 3,
      unique_id: "682f5dff937c4d809606cf389a678240",
      name: "Staying Active 202",
      class_code: "JFKXR9",
      grade: 9,
      is_elementary: false,
      date_created: "2024-05-07T18:11:39Z",
      date_modified: "2024-05-07T18:11:39Z",
      date_archived: null,
      archived_by: "",
      provider: {
        name: "Newsela",
        internal_name: "native",
        unique_id: null,
        is_bulk: false,
      },
      school: {
        id: 2000287682,
        pk: 2000287682,
        unique_id: "80e2fd9ef73f4c4e89927dc6891b1d11",
        name: "Lite District High School",
      },
      most_recent_sync_start_date: null,
      most_recent_sync_end_date: null,
      subjects: [],
      teachers: [
        {
          id: 8,
          pk: 8,
          unique_id: "2934df5d36514e6a8163348bfa6347b9",
          user: {
            id: 20,
            pk: 20,
            unique_id: "2934df5d36514e6a8163348bfa6347b9",
            first_name: "lite",
            last_name: "Teacher",
            last_login: "2024-10-15T16:19:09Z",
            social_auths: [],
          },
        },
      ],
      students: [
        {
          id: 21,
          pk: 21,
          unique_id: "46591c6f51dd41beb9d99b9d27fe45ce",
          user: {
            id: 31,
            pk: 31,
            unique_id: "46591c6f51dd41beb9d99b9d27fe45ce",
            first_name: "Andrew Arnold",
            last_name: "Daniel Sanders",
            last_login: null,
            social_auths: [
              {
                provider: "clever",
                uid: "12:55c4fc897e4b4f0d0066b85e",
              },
            ],
          },
        },
      ],
    },
    {
      id: 125,
      pk: 125,
      unique_id: "fecbb5e145654f8a815f5328479432bd",
      name: "Physical Education, Class 805 - Miller - 4",
      class_code: null,
      grade: 8,
      is_elementary: false,
      date_created: "2024-10-17T21:08:46Z",
      date_modified: "2024-10-17T21:08:46Z",
      date_archived: null,
      archived_by: "",
      provider: {
        name: "Clever",
        internal_name: "clever",
        unique_id: "65c53ffaec5d080881e6b9ff",
        is_bulk: true,
      },
      school: {
        id: 2000287767,
        pk: 2000287767,
        unique_id: "5a3571355b75461a81997c316982686a",
        name: "Skullround Middle School",
      },
      most_recent_sync_start_date: null,
      most_recent_sync_end_date: null,
      subjects: [
        {
          title: "Other",
          slug: "other",
          date_created: "2019-07-19T22:24:39Z",
          date_modified: "2019-07-19T22:24:39Z",
        },
      ],
      teachers: [
        {
          id: 123,
          pk: 123,
          unique_id: "80bb9315cfa948beb925ce28649e2cf5",
          user: {
            id: 933,
            pk: 933,
            unique_id: "80bb9315cfa948beb925ce28649e2cf5",
            first_name: "Sarah",
            last_name: "Miller",
            last_login: "2024-10-18T13:40:17Z",
            social_auths: [
              {
                provider: "clever",
                uid: "65c52b5fcf3c5a063d35ab25",
              },
              {
                provider: "google-oauth2",
                uid: "102955141948819173266",
              },
            ],
          },
        },
      ],
      students: [
        {
          id: 825,
          pk: 825,
          unique_id: "281c6dd3bdca400791fa11925274b7e8",
          user: {
            id: 977,
            pk: 977,
            unique_id: "281c6dd3bdca400791fa11925274b7e8",
            first_name: "Benjamin",
            last_name: "Jones",
            last_login: null,
            social_auths: [
              {
                provider: "clever",
                uid: "653937978780c5008754a0ab",
              },
            ],
          },
        },
      ],
    },
  ],
};

export const userClassroomsFiltersMock: UserClassroomsFilters = {
  page: 1,
  page_size: 50,
  sort: "name",
  q: "Class 1",
  hide_archived: false,
};

export const rosterChoiceMock: RosterChoiceResponse = {
  id: 1,
  provider: "google-oauth2",
};

export const rosterSyncResponseMock: RosterSyncResponse = [
  {
    expected_classroom_count: 1,
    has_failures: false,
    id: 16,
    provider: "google-oauth2",
    time_completed: new Date().toISOString(),
    time_started: new Date().toISOString(),
  },
];
